module.exports = __webpack_public_path__ + "static/media/userDefaultImage.d6759143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userDefaultImage.png
// module id = 82
// module chunks = 0